import { useEffect, useState } from 'react';

export function useDebounce<T>(value: T, delay: number, initialValue?: T) {
  const [debouncedValue, setDebouncedValue] = useState(initialValue ?? value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
